import { OpeningHours } from './lot.interface'

export interface Booking {
    lot_id: string
    lot_name: string
    lot_address: string
    lot_city?: string
    start_date: string
    end_date: string
    price: number
    hours?: number
    lotImage?: string
    lot_opening_hours?: OpeningHours
    lot_description?: {
        [key: string]: string
    }
    email?: string
    plates?: Plate[]
    payment_method?: string
    booking_ref?: string
    created_at?: string
    status?: BookingStatus
    booking_type?: BookingType
    night_parking_data?: {
        iso_duration: string
        rrule: string
    }[]
}

interface Plate {
    plate: string
}

export enum BookingStatus {
    ACTIVE = 'active',
    COMPLETED = 'expired',
    CANCELLED = 'cancelled',
    FUTURE = 'pending'
}

export enum BookingType {
    HOURLY = 'HOURLY',
    DAILY = 'DAILY',
    NIGHTLY = 'NIGHTLY'
}
